// @systeme: navigation-client
// ============================================================================
// PairsForm — lib/urls.ts : les quatre niveaux d'URL du client (lot 9.1)
// ============================================================================
// Modèle canonique §8.1 (GO FX 2026-10-13, détails D1-D8 du 2026-10-18) :
//   /                 public (catalogues, tunnel, pages à jeton — inchangé, D7)
//   /mon-espace       niveau PERSONNEL : la personne et ses casquettes (FX :
//                     « pas /moi » → le mot de la section du menu)
//   /o/:slug          niveau ORGANISATION : l'org dans l'URL (D2) — le slug de
//                     l'org du jeton, à défaut son id (N253 : slug nullable) ;
//                     la garde de route bascule le jeton quand le segment de
//                     l'URL diffère (droits vérifiés au switch, P8 inchangé)
//   /plateforme       niveau PLATEFORME : vues transversales des pilotes Cecodev
//
// Lot 9.6 (2026-10-18, D8) : les préfixes et les constructeurs purs vivent
// dans `@cecodev/shared` (`urls.ts`), la même source que les liens posés par
// le serveur dans les emails et les notifications (`utils/liens-client.ts`).
// Ce module n'y ajoute que l'ORG COURANTE du jeton : la barre latérale s'en
// sert pour masquer le sélecteur d'organisation sur les chemins personnels,
// les pages et le menu pour construire leurs liens (`urlOrg("/projets")`),
// le sélecteur d'org pour changer le segment d'une URL. Une URL héritée
// (ancien préfixe) entre dans routes/redirections.ts, jamais ici. Les
// garde-fous (check-liens-cablage, check-urls-heritees) lisent les appels
// `urlOrg(…)` / `urlMonEspace(…)` / `urlPlateforme(…)` comme des liens,
// préfixe reconstitué.
// ============================================================================

import { cheminMonEspace, cheminOrg, cheminPlateforme, segmentOrg } from "@cecodev/shared";

export {
  PREFIXE_MON_ESPACE,
  PREFIXE_PLATEFORME,
  PREFIXE_ORG,
  PREFIXES_PERSONNELS,
  segmentOrg,
  segmentEstIdentifiant,
  estCheminOrg,
  cheminSansOrg,
  estCheminPersonnel,
} from "@cecodev/shared";

/** URL du niveau personnel : `urlMonEspace("/inscriptions")` → `/mon-espace/inscriptions`. */
export function urlMonEspace(chemin = ""): string {
  return cheminMonEspace(chemin);
}

/** URL du niveau plateforme : `urlPlateforme("/opcos")` → `/plateforme/opcos`. */
function urlPlateforme(chemin = ""): string {
  return cheminPlateforme(chemin);
}

let segmentOrgCourant: string | null = null;

/**
 * Posé par `AuthProvider` à chaque rendu depuis la session (l'org portée par le
 * jeton) : les liens d'org construits pendant le rendu lisent cette valeur par
 * défaut, sans que chaque page ait à porter la session. Un sélecteur d'org
 * change l'URL, la garde de route change le jeton, la session change cette
 * valeur : les trois restent alignés.
 */
export function definirOrgCourante(slug: string | null | undefined, id: string | null | undefined): void {
  segmentOrgCourant = segmentOrg(slug, id);
}

/** URL du niveau organisation : `urlOrg("/projets")` → `/o/<org du jeton>/projets`, `urlOrg("", "client-x")` → `/o/client-x`. */
export function urlOrg(chemin = "", segment: string | null = segmentOrgCourant): string {
  return cheminOrg(segment ?? "-", chemin);
}
